// extracted by mini-css-extract-plugin
export default {"container":"PrivateRoutes_container__W2okA","outlet":"PrivateRoutes_outlet__cH33B"};